export var APP_MODE = process.env.NEXT_PUBLIC_APP_MODE === "sdk" ? "sdk" : "app";
